export default "__VITE_ASSET__b2e1f5fa__"